import { render, staticRenderFns } from "./vertical-form-table.vue?vue&type=template&id=7d4721c9&scoped=true&"
import script from "./vertical-form-table.vue?vue&type=script&lang=js&"
export * from "./vertical-form-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4721c9",
  null
  
)

export default component.exports